import React from 'react';
import styled from 'styled-components'
import { Link } from 'react-router-dom'

import Container from './../../common/components/Container';
import Row from './../../common/components/Row';
import Col from './../../common/components/Col';
import Logo from './../../common/components/Logo';
import UserMenu from './../../common/components/UserMenu';
// import Mainmenu from './Mainmenu';

const Wrapper = styled.div.withConfig({displayName:'-Wrapper'})`
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 76px;
  background-color: #ffffff;
  color: #ffffff;
  z-index: 999;
  box-shadow: 0 2px 8px rgba(0,0,0,0.5);
  padding: 8px 16px;
`;
const LogoWrapper = styled.div.withConfig({displayName:'-LogoWrapper'})`
  margin: 4px 0px 3px;
`;

const Topbar = ({layout}) => {

  return (
    <Wrapper collapseOnSelect expand="lg">
      <Container>
        <Row align="center">
          <Col width={2}>
            <Link to="/">
              <LogoWrapper>
                <Logo height="53px" />
              </LogoWrapper>
            </Link>
          </Col>
          <Col width={7}>
            {/*<Mainmenu layout={layout} />*/}                  
          </Col>
          <Col width={3}>
            <UserMenu />                  
          </Col>
        </Row>
      </Container>
    </Wrapper>
  )
}

export default Topbar
